import React, { forwardRef, useRef } from "react"
import { Box, Container, Grid, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material"
import Image from "next/image"

// Images
import Shop from "public/images/icons/shopping-bag.png"
import User from "public/images/icons/user.png"
import Wifi from "public/images/icons/wifi.png"


import MainCard from "src/components/common/main-card"
import Vanta from "../../../vanta"
import MobileAppBar from "../app-bar"

// Swiper
import { ParallaxProvider } from "react-scroll-parallax"
import { Autoplay } from "swiper"
import "swiper/css"
import { Swiper, SwiperSlide } from "swiper/react"
import MainSlider from "../../desktop/header/components/MainSlider"

// ---------------------------------------------------------------------------------------------------------------------
// eslint-disable-next-line react/display-name
const PureCanvas = forwardRef((props, ref) => <canvas ref={ref} />)
const MobileHeader = () => {
  const vantaRef = useRef(null)
  return (
    <ParallaxProvider>
      <Vanta childrenRef={vantaRef}>
        <Box ref={vantaRef}>
          <Container
            sx={{
              alignItems: "center",
              mb: 5,
              minHeight: "100vh"
            }}
          >
            <MobileAppBar />
            <Grid
              container
              sx={{
                minHeight: "calc(100vh - 170px)",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
                padding: 1,
              }}
            >
              <MainSlider />
            </Grid>
            <Box sx={{ pb: 3 }}>
              <Swiper
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false
                }}
                pagination={true}
                modules={[Autoplay]}
              >
                <SwiperSlide>
                  <MainCard
                    shadow={3}
                    sx={{
                      borderRadius: "25px",
                      background: "rgba(6, 5, 19, 0.4)",
                      backdropFilter: "blur(5px)",
                      color: "#fff"
                    }}
                  >
                    <ListItem>
                      <ListItemIcon>
                        <Image src={User} alt='user' width={35} />
                      </ListItemIcon>
                      <ListItemText
                        primary={<Typography variant='h5'>با ارائه ضامن</Typography>}
                        secondary={<Typography variant='caption'>به همراه یک برگ چک صیادی</Typography>}
                      />
                    </ListItem>
                  </MainCard>
                </SwiperSlide>
                <SwiperSlide>
                  <MainCard
                    shadow={3}
                    sx={{
                      borderRadius: "25px",
                      background: "rgba(6, 5, 19, 0.4)",
                      backdropFilter: "blur(5px)",
                      color: "#fff"
                    }}
                  >
                    <ListItem>
                      <ListItemIcon>
                        <Image src={Shop} alt='user' width={45} />
                      </ListItemIcon>
                      <ListItemText
                        primary={<Typography variant='h5'>خرید از شبکه پذیرندگان منتخب</Typography>}
                        secondary={<Typography variant='caption'>از فروشگاه های معتبر و متنوع خرید کن</Typography>}
                      />
                    </ListItem>
                  </MainCard>
                </SwiperSlide>
                <SwiperSlide>
                  <MainCard
                    shadow={3}
                    sx={{
                      borderRadius: "25px",
                      background: "rgba(6, 5, 19, 0.4)",
                      backdropFilter: "blur(5px)",
                      color: "#fff"
                    }}
                  >
                    <ListItem>
                      <ListItemIcon>
                        <Image src={Wifi} alt='user' width={35} />
                      </ListItemIcon>
                      <ListItemText
                        primary={<Typography variant='h5'>فرایند تماماً آنلاین</Typography>}
                        secondary={<Typography variant='caption'>از خونه درخواست وام بده</Typography>}
                      />
                    </ListItem>
                  </MainCard>
                </SwiperSlide>
              </Swiper>
            </Box>
          </Container>
        </Box>
      </Vanta>
    </ParallaxProvider>
  )
}

export default MobileHeader
